import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Stream from 'flarum/common/utils/Stream';
export default class SignatureState {
  constructor() {
    // The content of the signature
    _defineProperty(this, "content", void 0);
    // Indicates whether the signature is being edited
    _defineProperty(this, "editing", void 0);
    this.content = Stream('');
    this.editing = false;
  }

  // Sets the content of the signature
  setContent(content) {
    this.content = content;
  }

  // Toggles the editing state
  toggleEditing() {
    this.editing = !this.editing;
  }
}
flarum.reg.add('fof-signature', 'forum/states/SignatureState', SignatureState);